import React from 'react';
import PageContainer from '../../components/PageContainer/index';
import { TabPanel, TabPanels } from '@chaser/components';
import Notifications from './components/Notifications';
import NavigationTabs from '../../components/NavigationTabs';
import Security from './components/Security';
import Profile from './components/Profile';

const Account = () => {
  return (
    <PageContainer>
      <NavigationTabs
        basePath="/user"
        tabs={[
          { path: 'profile', title: 'Profile' },
          { path: 'notifications', title: 'Notifications' },
          { path: 'security', title: 'Security' },
        ]}
        menuOnMobile
      >
        <TabPanels>
          <TabPanel>
            <Profile />
          </TabPanel>
          <TabPanel>
            <Notifications />
          </TabPanel>
          <TabPanel>
            <Security />
          </TabPanel>
        </TabPanels>
      </NavigationTabs>
    </PageContainer>
  );
};

export default Account;
